export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '内部划转记录';